module.exports = __webpack_public_path__ + "static/media/default.1052c48a.png";